
/**
 * @nullable
 */
export type MarkNotificationAsFailed200Data = {[key: string]: unknown} | null;
